import axios from 'axios'
import {GlavnaKnjigaModel, ParamsModelGlavnaKnjiga} from '../models/GlavnaKnjigaModel'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/paneli/glavnaKnjigaProizvodnje`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getGlavnaKnjiga(params: ParamsModelGlavnaKnjiga) {
  return await axios.get<Array<GlavnaKnjigaModel>>(API, {headers: headers, params: params})
}

export async function saveGlavnaKnjiga(Data: any) {
  try {
    const response = await axios.post(API, Data, {headers: headers})

    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error Saving data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function fetchGlavnaKnjiga(Id: number): Promise<Partial<GlavnaKnjigaModel>> {
  try {
    const response = await axios.get(`${API}/${Id}`)
    if (response.data && response.data.error === 0) {
      return response.data.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error fetching data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function updateGlavnaKnjiga(id: number, Data: any) {
  try {
    const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      return response.data.message || 'Failed to fetch.'
    }
  } catch (error) {
    return  error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function deleteGlavnaKnjiga(Id: number) {
  try {
    const response = await axios.delete(`${API}/${Id}`, {headers: headers})
    if (response.data) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to delete.')
    }
  } catch (error) {
    console.error('Error deleting data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function saveSkartDimenzije(Data: any) {
  try {
    const response = await axios.post(`${API_URL}/paneli/skartDimenzije`, Data, {headers: headers})

    if (response.data.error === 0) {
      return response.data
    } else {
      // Handle any other type of response structure or errors returned from the server here
      throw new Error(response.data.message || 'Failed to fetch.')
    }
  } catch (error) {
    console.error('Error Saving data:', error)
    throw error // Re-throw the error so it can be handled by the caller if necessary
  }
}

export async function getPaneliSkartDropdown() {
  return await axios.get(`${API_URL}/paneli/paneliSkartDropdown`, {
    headers: headers,
  })
}
export async function getPaneliSkartAllDropdown() {
  return await axios.get(`${API_URL}/paneli/paneliSkartAllDropdown`, {
    headers: headers,
  })
}
export async function getSmjenePanelaDropdown() {
  return await axios.get(`${API_URL}/paneli/smjenePanela`, {
    headers: headers,
  })
}
export async function getMasinePanelaDropdown() {
  return await axios.get(`${API_URL}/paneli/masinePanela`, {
    headers: headers,
  })
}